import axios from '@/utils/request/index.js'

const base = async (body) => {
  try {
    const { data } = await axios.post('/system/dict/search', body)
    return data.data
  } catch (error) {
    
    throw error
  }
}

export default {
  base,
}